module.exports = __webpack_public_path__ + "img/graph-green.08f3ebd2.png";